import React, { useState } from "react";
import { Container, Paper } from "@material-ui/core";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import LoyaltySettings from "./LoyaltySettings";
import LoyaltyPerLevel from "./LoyaltyPerLevel";
import LoyaltyRewards from "./LoyaltyRewards";
import LoyaltyToUser from "./LoyaltyToUser";
import { connect } from "react-redux";

const Loyalty = ({ isUserManager }) => {
	const [display, setDisplay] = useState("");
	const returnButton = <ButtonWithStyle onClick={() => setDisplay("")}>Regresar</ButtonWithStyle>;

	const options = (
		<>
			<ButtonWithStyle
				onClick={() => {
					setDisplay("rewardsPerLevel");
				}}
			>
				Configurar premios por nivel
			</ButtonWithStyle>
			<ButtonWithStyle
				onClick={() => {
					setDisplay("rewards");
				}}
			>
				Premios
			</ButtonWithStyle>
			{isUserManager ? (
				<>
					<ButtonWithStyle
						onClick={() => {
							setDisplay("settings");
						}}
					>
						Configuración general
					</ButtonWithStyle>
					<ButtonWithStyle
						onClick={() => {
							setDisplay("loyaltyToUser");
						}}
					>
						Asignar nivel a un usuario
					</ButtonWithStyle>
				</>
			) : null}
		</>
	);

	const displaySwitch = () => {
		switch (display) {
			case "settings":
				return <LoyaltySettings />;
			case "rewardsPerLevel":
				return <LoyaltyPerLevel />;
			case "rewards":
				return <LoyaltyRewards />;
			case "loyaltyToUser":
				return <LoyaltyToUser />;
			default:
				return options;
		}
	};
	return (
		<Container style={{ padding: "1em", maxWidth: "1200px" }}>
			<Paper style={{ padding: "1em", textAlign: "center" }}>
				{display ? returnButton : null}
				{displaySwitch()}
			</Paper>
		</Container>
	);
};

const mapStateToProps = ({ auth }) => {
	const isUserManager = auth?.databasesRef?.isUserManager;
	return { isUserManager };
};
export default connect(mapStateToProps)(Loyalty);
